export default () => {
  Date.shortMonths = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

  function addDays(e, t) {
    return e.setDate(e.getDate() + t), e;
  }

  function short_months(e) {
    return Date.shortMonths[e.getMonth()];
  }

  var count_date_el = document.getElementById("countdown");


  if ("undefined" != typeof count_date_el && null != count_date_el)
    var today = new Date(),
      next_date_count = addDays(today, 1),
      current_year = next_date_count.getFullYear(),
      current_day = next_date_count.getDate(),
      str_next_day = short_months(next_date_count) + " " + current_day + ", " + current_year + " 00:00:00",
      countDownDate = new Date(str_next_day).getTime(),
      x = setInterval(function () {
        var e = new Date().getTime(),
          t = countDownDate - e,
          i = Math.floor(t / 864e5),
          n = Math.floor((t % 864e5) / 36e5),
          o = Math.floor((t % 36e5) / 6e4),
          s = Math.floor((t % 6e4) / 1e3);
        (document.getElementById("countdown").innerHTML =
          '<span class="d-flex align-items-center p-1 p-md-2"><span class="border border-dark bg-secondary rounded-pill lh-lg fw-bold px-2 py-1" style="width: 36px; height: 36px;">' +
          i +
          '</span><span class="fw-bold ms-1 ms-md-2">ngày</span></span> <span class="d-flex align-items-center p-1 p-md-2"><span class="border border-dark bg-secondary rounded-pill lh-lg fw-bold px-2 py-1" style="width: 36px; height: 36px;">' +
          n +
          '</span><span class="fw-bold ms-1 ms-md-2">giờ</span></span> <span class="d-flex align-items-center p-1 p-md-2"><span class="border border-dark bg-secondary rounded-pill lh-lg fw-bold px-2 py-1" style="width: 36px; height: 36px;">' +
          o +
          '</span><span class="fw-bold ms-1 ms-md-2">phút</span></span>  <span class="d-flex align-items-center p-1 p-md-2"><span class="border border-dark bg-secondary rounded-pill lh-lg fw-bold px-2 py-1" style="width: 36px; height: 36px;">' +
          s +
          '</span><span class="fw-bold ms-1 ms-md-2">giây</span></span>'),
        t < 0 && (clearInterval(x), (document.getElementById("countdown").innerHTML = "EXPIRED"));
      }, 1e3);
}
